import React, { forwardRef } from "react";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import UiInput from "../../../_uiComponents/UiInput";
import UiSelect from "../../../_uiComponents/UiSelect";
import {
     UiButton,
     UiToggleButton,
} from "../../../../_uiComponents/common/form/UiButton";
import UiDateRangePicker from "../../../_uiComponents/UiDateRangePicker";
import UiInnerSearchWr from "../../../../_uiComponents/common/UiInnerSearchWr";
import UiMultipleSelect from "../../../_uiComponents/UiMultipleSelect";

export default function CampaignManagementFilterForm(props) {
     const [character, setCharacter] = React.useState("");
     const [contains, setContains] = React.useState("");

     const handleChange = (event) => {
          setCharacter(event.target.value);
     };

     const handleContainChange = (event) => {
          setContains(event.target.value);
     };

     const options = [
          { value: "value-1", label: "text-1" },
          { value: "value-2", label: "text-2" },
          { value: "value-3", label: "text-3" },
     ];

     return (
          <>
               {/* <SearchBarWr> */}
             
                                   <>
                                        <UiInnerSearchWr>
                                             <Grid container spacing={2}>
                                                  <Grid item xs="12" lg="9">
                                                       <Grid
                                                            container
                                                            spacing={2}
                                                       >
                                                            <Grid
                                                                 item
                                                                 xs="12"
                                                                 lg="4"
                                                                 className="sba-search-input"
                                                            >
                                                                 <UiInput
                                                                      name="eee"
                                                                      type="text"
                                                                      label="Campaign Name"
                                                                 />
                                                            </Grid>

                                                            <Grid
                                                                 item
                                                                 xs="12"
                                                                 lg="4"
                                                            >
                                                                 <UiMultipleSelect
                                                                      name="eee"
                                                                      label="Multiple Select"
                                                                 />
                                                            </Grid>

                                                            <Grid
                                                                 item
                                                                 xs="12"
                                                                 lg="4"
                                                            >
                                                                 <UiSelect
                                                                      name="eee"
                                                                      label="Type"
                                                                      value={
                                                                           character
                                                                      }
                                                                      handleChange={
                                                                           handleChange
                                                                      }
                                                                      options={
                                                                           options
                                                                      }
                                                                 />
                                                            </Grid>

                                                            <Grid
                                                                 item
                                                                 xs="12"
                                                                 lg="4"
                                                            >
                                                                 <UiDateRangePicker name="eee" />
                                                            </Grid>

                                                            <Grid
                                                                 item
                                                                 xs="12"
                                                                 lg="4"
                                                            >
                                                                 <UiSelect
                                                                      name="eee"
                                                                      label="Status"
                                                                      value={
                                                                           contains
                                                                      }
                                                                      handleChange={
                                                                           handleContainChange
                                                                      }
                                                                      options={
                                                                           options
                                                                      }
                                                                 ></UiSelect>
                                                            </Grid>
                                                       </Grid>
                                                  </Grid>
                                                  <Grid item xs="12" lg="3">
                                                       <Stack
                                                            spacing={2}
                                                            direction="row"
                                                            justifyContent="end"
                                                            sx={{
                                                                 width: "100%",
                                                                 pt: 0.6,
                                                            }}
                                                       >
                                                            <UiButton
                                                                 name="Clear"
                                                                 variant="outlined"
                                                                 size="small"
                                                            />
                                                            <UiButton
                                                                 name="Apply"
                                                                 variant="contained"
                                                                 size="small"
                                                            />
                                                       </Stack>
                                                  </Grid>
                                             </Grid>
                                        </UiInnerSearchWr>
                                   </>
                            
               {/* </SearchBarWr> */}
          </>
     );
}
